// mui
import {
	Accordion as MuiAccordion,
	AccordionDetails,
	AccordionDetailsProps as MuiAccordionDetailsProps,
	AccordionProps as MuiAccordionProps,
	AccordionSummary,
	AccordionSummaryProps as MuiAccordionSummaryProps,
	Typography,
	Grid,
} from '@mui/material';

// ui
import { IconCircle, IconCircleProps } from '../IconCircle/IconCircle';

// icons
import { ExpandMoreOutlined as IconExpandMore } from '@mui/icons-material';

// props
export interface AccordionItem {
	AccordionProps?: Omit<MuiAccordionProps, 'children'>;
	AccordionSummaryProps: MuiAccordionSummaryProps & {
		IconCircleProps?: IconCircleProps;
	};
	AccordionDetailsProps: MuiAccordionDetailsProps;
}

export interface AccordionProps {
	items: AccordionItem[];
}

export const Accordion = ({ items }: AccordionProps) => {
	return (
		<>
			{items.map((item, index) => {
				const { AccordionProps, AccordionSummaryProps, AccordionDetailsProps } = item;
				const isFirst = index === 0;
				return (
					<MuiAccordion
						sx={(theme) => {
							return {
								backgroundColor: theme.palette.grey[50],
								borderColor: theme.palette.divider,
								borderStyle: 'solid',
								borderWidth: 1,
								borderTopWidth: isFirst ? 1 : 0,
								boxShadow: 'none',
								margin: 0,
								'&.Mui-expanded': {
									backgroundColor: theme.palette.common.white,
									margin: 0,
								},
							};
						}}
						{...AccordionProps}>
						<AccordionSummary
							expandIcon={<IconExpandMore />}
							aria-controls="accordion-1-content"
							id="accordion-1-header"
							sx={(theme) => {
								return {
									'& .MuiAccordionSummary-content': {
										margin: theme.spacing(1.5, 0),
										'&.Mui-expanded': {
											margin: theme.spacing(1.5, 0),
										},
									},
									'&.Mui-expanded': {
										minHeight: 0,
									},
								};
							}}
							{...AccordionSummaryProps}>
							<Grid alignItems="center" container spacing={1}>
								{AccordionSummaryProps.IconCircleProps && (
									<Grid item>
										<IconCircle size="xs" {...AccordionSummaryProps.IconCircleProps} />
									</Grid>
								)}
								<Grid item>
									<Typography component="span" fontWeight={600}>
										{AccordionSummaryProps.children}
									</Typography>
								</Grid>
							</Grid>
						</AccordionSummary>
						<AccordionDetails
							sx={(theme) => {
								return {
									paddingTop: 0,
								};
							}}
							{...AccordionDetailsProps}
						/>
					</MuiAccordion>
				);
			})}
		</>
	);
};
